module.exports = __webpack_public_path__ + "img/pieceOneImg2.5cac523.png";